import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as moment from 'moment';
import { OnboardingMenu } from 'src/app/enums/enums';
import { ConfigurationService } from 'src/app/services/core/configuration/configuration.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { UploadService } from 'src/app/services/core/documents/upload.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { validateFileSize } from 'src/app/utils/common.utils';
import { addressValidator } from 'src/app/utils/custom-validators';
import { imageProcessing, ImageSnippet } from 'src/app/utils/image-processing-utils';
import { sweetAlert } from 'src/app/utils/swal';
import { urls } from 'src/app/utils/url.utils';
import { getFileNameFromUrl, onTimeChange, uploadDocumentImages } from 'src/app/utils/utils.common';
@UntilDestroy()

@Component({
  selector: 'app-add-vehicle',
  templateUrl: './add-vehicle.component.html',
  styleUrls: ['./add-vehicle.component.css']
})
export class AddVehicleComponent implements OnInit {
  submitted = false;
  vehicleForm!: FormGroup
  companyId: any;
  vehicleId: any;
  spaceTypes: any;
  selectedSpaceTypes = [];
  selectedFile: ImageSnippet | null = null;
  status = true;
  currentPage: number = 1;
  // Edit Modal Inputs and Outputs
  @Input() vehicle: any;
  @Input() source: any;
  @Output() onSaveVehicle = new EventEmitter<string>();
  @Output() onCloseModal = new EventEmitter<string>();
  // Edit Modal Inputs and Outputs End
  
  constructor(
    private uploadService: UploadService,
    private spaceTypeService: SpaceTypeService,
    private cedentialService: CredentialService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder) { }

  ngOnInit(): void {

    if (this.source === 'modal' && this.vehicle) {
      this.vehicleId = this.vehicle.id;
      this.companyId = this.vehicle.company;
      this.getVehicleById();
    } else {
      this.vehicleId = this.route.snapshot.params['vehicleId'];
      this.companyId = this.route.snapshot.params['companyId'];
      if (this.vehicleId) {
        this.getVehicleById();
      }
    }


    this.vehicleForm = this.fb.group({
      description: ['', Validators.required],
      vin: ['', Validators.required],
      licensePlateNumber: ['', Validators.required],
      year: ['', Validators.required],
      make: ['', Validators.required],
      model: ['', Validators.required],
      color: ['', Validators.required],
      spaceType: ['', Validators.required],
      garageAddress: this.fb.group({
        name: ['', Validators.required],
        coords: [[]],
        city: ['', Validators.required],
        state: ['', Validators.required]
      }, { validators: addressValidator() }),
      serviceAreas: [''],
      images: this.fb.group({
        registration: [],
        inspectionReport: [],
        vehicle: [],
        back: [],
        left: [],
        right: [],
      }),
      dates: this.fb.group({
        registrationDate: [],
        registrationExpireDate: [],
        inspectionDate: [],
        inspectionExpireDate: []
      }),
      company: [''],
      isActive: [false, Validators.required],
    });

    this.getSpaceType();

    if (this.vehicleId) {
      this.getVehicleById();
    }
    this.validateLinkedDates(this.datesForm, 'registrationDate', 'registrationExpireDate');
    this.validateLinkedDates(this.datesForm, 'inspectionDate', 'inspectionExpireDate');
  }

  get form() {
    return this.vehicleForm.controls;
  }

  get imagesForm() {
    return this.vehicleForm.controls.images as FormGroup;
  }

  get garageAddressForm() {
    return this.vehicleForm.controls.garageAddress as FormGroup
  }

  get datesForm() {
    return this.vehicleForm.controls.dates as FormGroup;
  }

  onSave() {
    this.submitted = true;
    this.vehicleForm.patchValue({
      company: this.companyId,

    });
    if (this.vehicleForm.invalid) return;

    let payload = this.vehicleForm.value;
    // delete payload.dates.preInspectionReport,
    // delete payload.dates.preRegistration,

    this.cedentialService.saveVehicle(this.vehicleId, payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        // this.router.navigateByUrl(`/credentials/${this.companyId}`);
        if (this.source === 'modal') {
          this.onSaveVehicle.emit(data);
        } else {
          this.router.navigate(['/credentials', this.companyId], { fragment: OnboardingMenu.VEHICLES });
        }
      }
    },
      (err) => {
        sweetAlert("Error", err, "error", "OK");
      }
  )
  }

  getSpaceType() {
    const queryParams = {
      limit: 9999,
      isActive: this.status
    }
    this.spaceTypeService.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results ) {
        this.spaceTypes = data.results;
      }
    })
  }


  getVehicleById() {
    this.cedentialService.getVehicleById(this.vehicleId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.vehicleForm.patchValue(data)

      }
    })
  }

  // ---Generic Method for upload documents

  uploadDocumentImages(documents: any, formControl: AbstractControl<any, any> | null) {
       const file = documents.files?.[0];
  if (!validateFileSize(file)) {
  documents.value = ''; // reset the file input
  return;
}
    uploadDocumentImages(documents, formControl, this.uploadService, urls.VEHICLES)
  }

  getFileName(url: any) {
    return getFileNameFromUrl(url);
  }

  // Generic Method for select datetime

  onDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName)
  }

  deleteFile(formControl: AbstractControl<any, any> | null, fileInput: HTMLInputElement) {
    formControl?.setValue(null); // Safely calls setValue if formControl is not null
    if (fileInput) {
      fileInput.value = '';
    }
  }

  validateLinkedDates(formGroup: FormGroup, startCtrl: string, endCtrl: string) {
    formGroup.valueChanges.subscribe(values => {
      const start = values[startCtrl];
      const end = values[endCtrl];

      const startControl = formGroup.get(startCtrl);
      const endControl = formGroup.get(endCtrl);

      if (start && end && new Date(start) >= new Date(end)) {
        endControl?.setErrors({ dateMismatch: true });
      } else {
        if (endControl?.hasError('dateMismatch')) {
          endControl.setErrors(null);
        }
      }
    });
  }

  onSelectAddress(place: any): void {
    const selectedAddress = place.address_components;
    const city = selectedAddress.find((data: any) =>
      data.types.includes('locality') || data.types.includes('administrative_area_level_2')
    );
    const cityName = city ? city.long_name : '';
    const state = selectedAddress.find((data: any) =>
      data.types.includes('administrative_area_level_1')
    );
    const stateName = state ? state.long_name : '';
    this.vehicleForm.patchValue({
      garageAddress: {
        city: cityName,
        state: stateName,
        name: place.formatted_address,
        coords: [
          place.geometry.location.lng(),
          place.geometry.location.lat()
        ]
      }
    });
  }

  onChangeAddress(){
      this.vehicleForm.patchValue({
      garageAddress: {
       city: '',
        state: '',
        coords: ''
      }
    });
  }
}
